module.exports = __webpack_public_path__ + "media/images/our_apps/smart_tv_mobile-ce896f0209cc2d0e8aef24db23faab28.png";